module.exports = __webpack_public_path__ + "img/DE00022.3eefb392.svg";